import React from 'react'
import 'css/components/auth-card.css'
import { AuthBackdrop } from 'auth/auth-backdrop'

/**
 * The shared shell and head of every account screen: eyebrow, title, rule and sub-copy, on the
 * decorative backdrop. Pages put their own form inside it.
 *
 * I/O contract: props in, markup out; it reads no state and calls nothing. Class names it renders
 * (and the ones pages use inside it) are defined in css/components/auth-card.css, the only place
 * these screens are styled.
 *
 * `bare` drops the full-page backdrop wrapper, for the student class-code page, which sits inside
 * its own header/footer shell instead of the app's navbar and footer.
 */
export interface AuthCardProps {
	eyebrow: string
	title: React.ReactNode
	subtitle?: React.ReactNode
	/** the narrower card the design uses for log in (393px instead of 440px) */
	narrow?: boolean
	bare?: boolean
	children?: React.ReactNode
}

export const AuthCard = ({ eyebrow, title, subtitle, narrow = false, bare = false, children }: AuthCardProps) => {
	const card = (
		<section className={`auth-card${narrow ? ' auth-card--narrow' : ''}`}>
			<span className="auth-eyebrow">{eyebrow}</span>
			<h1 className="auth-title">{title}</h1>
			<div className="auth-rule" />
			{subtitle !== undefined && subtitle !== null && <p className="auth-sub">{subtitle}</p>}
			{children}
		</section>
	)
	if (bare) return card
	return (
		<div className="auth-page">
			<AuthBackdrop />
			{card}
		</div>
	)
}

/** The "or" rule between the form and the closing prompt. */
export const AuthDivider = () => <div className="auth-divider"><span>or</span></div>
